import React, { lazy, useEffect, useContext } from 'react';
import Suspense from '../../element/Suspense';
import { SubmenuContext } from '../../element/Menu/submenuContext';
import SubMenuItems from '../../element/Menu/SubMenuItems';
import { RouteComponentProps } from 'react-router-dom';

const MyContributionsView = lazy(() => import('./view'));

const MyContributions: React.FC<RouteComponentProps> = (props): React.ReactElement => {
  const { setSubmenu } = useContext(SubmenuContext);
  useEffect(() => {
    if (setSubmenu) {
      setSubmenu(SubMenuItems.myContributions.key);
    }
  }, [setSubmenu]);

  return (
    <Suspense>
      <MyContributionsView {...props} />
    </Suspense>
  );
};

export default MyContributions;
